import { isServerSide } from "@jti/fe-common";

export const redirectToAuthPage = (resolvedAuthHref: string) => {
  if (isServerSide()) {
    return;
  }

  window.location.href = resolvedAuthHref;
};
